/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Link, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { LoadState } from "../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../hooks";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import {
  downloadCommAutomobileConsentFormPDFAsync,
  downloadCommAutomobileOcep16PDFAsync,
  downloadCommAutomobileRetireeDiscountPDFAsync,
  fetchCommAutomobileConsentFormListAsync,
  fetchCommAutomobileRetireeDiscountListAsync,
  previewCommAutomobileConsentFormPDFAsync,
  previewCommAutomobileOcep16PDFAsync,
  previewCommAutomobileRetireeDiscountPDFAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoCertificates/commAutoCertificatesActions";
import { ICommAutomobileRetireeDiscount } from "../../../../../../redux/commAutoPolicy/commAutoCertificates/commAutoCertificates.types";
import { CustomSelect } from "../../../../../../components/formsComponents";
import { renderDropdownValue } from "../../../../../../helpers";
import { NotificationsActive, ThumbUpAlt } from "@mui/icons-material";
import { CustomChip } from "../../../../../../components/CustomChip";
import { LeadOppStatus } from "../../../../../../components/LeadOppStatus/LeadOppStatus";

export const CommAutoRetireeDiscountList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { list, loading } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.certificates.retireediscount
  );
  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useDispatchWrapper();

  const [selectedConsent, setselectedConsent] = React.useState<{
    isAllSelected: boolean;
    certificate: ICommAutomobileRetireeDiscount[];
  }>({
    isAllSelected: false,
    certificate: [],
  });

  const menuItems =
    selectedConsent.certificate.length > 0 || selectedConsent.isAllSelected
      ? [
          {
            key: "action",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={""}
                displayEmpty
                renderValue={renderDropdownValue(`Choose bulk Action`)}
                //onChange={(e) => setBranchOffice(e.target.value as string)}
              >
                <MenuItem value="1">Email</MenuItem>
              </CustomSelect>
            ),
          },
        ]
      : [];

  const RetireeDiscountTableProps: IDataTableProps = {
    isPagination: true,
    isDataLoading: loading === LoadState.InProgress,
    selectionMode: "multiple",
    uniqueRowKeyName: "incemental_number",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [...menuItems],
      },
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/retiree-discount`
                  );
                }}
              >
                + Create
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
    {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICommAutomobileRetireeDiscount) => {
          return (
            <StandardTableActions
              downloadLoading={downloading}
              onDownloadPreview={() => {
                dispatch(
                  previewCommAutomobileRetireeDiscountPDFAsync(
                    customerPolicyId,
                    row.incremental_number as number,
                    () => {}
                  )
                );
              }}
              onDownLoadClick={() => {
                if (row.incremental_number) {
                  setDownloading(true);
                  dispatch(
                    downloadCommAutomobileRetireeDiscountPDFAsync(
                      customerPolicyId,
                      row.incremental_number,
                      () => {
                        setDownloading(false);
                      }
                    )
                  );
                }
              }}
              onEditClick={() => {
                navigate(
                  `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/retiree-discount/${row.incremental_number}`
                );
              }}
              // onDuplicateClick={() => {
              //   navigate(
              //     `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/consent-form-duplicate/${row.incremental_number}`
              //   );
              // }}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICommAutomobileRetireeDiscount) => {
          return <LeadOppStatus status={row.status} />;
        },
      },
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: ICommAutomobileRetireeDiscount) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/retiree-discount/${row.incremental_number}`
                );
              }}
            >
              {row.incremental_number}
            </Link>
          );
        },
      },
      {
        key: "customer_name",
        headerName: "Customer Name",
        fieldName: "customer_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "effective_date_of_discount",
        headerName: "Effective Date",
        fieldName: "effective_date_of_discount",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "insurer",
        headerName: "Insurance Company",
        fieldName: "insurer",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "retiree_name",
        headerName: "Retiree Name",
        fieldName: "retiree_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "branch_code",
        headerName: "Broker/Agent",
        fieldName: "branch_code",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      
    ],
    items: list,
    onSelection: (isAllSelected: boolean, rows: ICommAutomobileRetireeDiscount[]) => {
        setselectedConsent({ isAllSelected: isAllSelected, certificate: rows });
    },
  };

  React.useEffect(() => {
    dispatch(fetchCommAutomobileRetireeDiscountListAsync(customerPolicyId));
  }, [customerPolicyId]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...RetireeDiscountTableProps} />
      </Box>
    </>
  );
};
